export default {
  namespaced: true,
  operational_security: {
    title: "Segurança operacional",
    template: {
      title: " Modelo de Formulário| Modelos de Formulário",
      name: "Nome",
      question: "Pergunta | Perguntas",
      add_new_field: "Adicionar um Novo Campo",
      type_response: "Tipo de Resposta",
      field_name: "Nome do Campo",
      field_types: "Tipos de Campo",
      field_type_config: "Configuração do Tipo de Campo",
      options: "Opções",
      option_name: "Nome da Opção",
      add_option: "Adicionar uma Opção",
      added_options: "Opções Adicionadas",
      add_section: "Adicionar seção",
      new_section: "Nova seção",
      section_name: "Nome da seção",
      no_section: "Sem seção",
      add_field_here: "Adicionar pergunta",
      confirm_delete_section:
        "Excluir a seção? Suas perguntas serão movidas para 'Sem seção'.",
      confirm_delete_field: "Excluir esta pergunta?",
      is_group: "Múltiplo"
    },
    evaluation: {
      title: "Respostas do formulário",
      command_executed: "Comando executado",
      command_queued: "Comando na fila",
      command_running: "Executando comando",
      command_succeeded: "Comando executado com sucesso",
      command_failed: "Falha ao executar o comando",
      command_retry: "Tentar novamente",
      command_check_result: "Consultar resultado",
      command_tracking_error: "Não foi possível iniciar ou confirmar a execução do comando.",
      command_tracking_timeout: "A execução continua sem resultado confirmado. Consulte novamente a mesma tentativa.",
      command_retry_title: "Tentar comando novamente",
      command_retry_warning: "A tentativa anterior pode ter sido executada parcialmente. Deseja executar o comando novamente?",
      select_form: "Selecione o formulário de segurança operacional",
      new_evaluation: "Responder formulário",
      edit_evaluation: "Editar respostas do formulário",
      form_start_at: "Data de início",
      form_end_at: "Data de término",
      sent_to: "Enviado para",
      shortcuts: "Atalhos",
      status: {
        in_progress: "Em Andamento",
        pending: "Pendente",
        review: "Em Revisão",
        completed: "Concluído",
        rejected: "Rejeitado",
        reopened: "Reasignado",
        in_review: "En revisión",
        approved: "Aprobado",
        canceled: "Cancelado",
        commented: "Comentado",
        updated: "Actualizado"
      },
      email_preview: "visualização do e-mail",
      validation_comments: "Comentários sobre a validação",
      reopened_comments: "Comentários do formulário reaberto",
      create_sitrep: "Criar SITREP",
      create_newsletter: "Criar boletim informativo",
      create_news_flash: "Criar ⁠⁠flash informativo",
      create_informative_email: "Criar Correio informativo",
      send_form: "Enviar formulário",
      error_send_form: "Erro ao enviar o formulário",
      success_send_form: "Formulário enviado com sucesso",
      answers_successfully: "Respostas salvas com sucesso",
      answers_error: "Erro ao salvar respostas",
      reload: "Recarregar",
      review_successfully: "Enviado para revisão com sucesso",
      review_error: "Erro ao enviar o formulário para revisão",
      status_successfully: "Status atualizado com sucesso",
      status_error: "Erro ao atualizar o status",
      reopen_successfully: "Formulário reaberto com sucesso",
      reopen_error: "Erro ao reabrir o formulário",
      related_forms: "Formulários relacionados",
      mailable: "Enviável",
      standard: "Padrão",
      loading_tracking: "Carregando o rastreamento do formulário...",
      create: "Criar",
      does_not_apply: "Não se aplica"
    },
    prefill: {
      title: "Pré-inscrições",
      search: "Pesquisa por referência, SOEID, filial",
      create: "Criar Pré-Registro",
      table_tooltip: "Arraste e solte um pré-registro para preencher o formulário",
      reference: "Referência",
      facility: "Filial",
      event_type: "Tipo de Evento",
      date: "Data",
      questions: "Perguntas",
      another_facility: "Outro imóvel",
      close: "Fechar pré-inscrição",
      edit: "Editar Pré-Registro",
    },
    operational_processes: {
      title: "Controle de acesso de pessoas externas",
      folio: "ID do registrooo",
      unit: "Instalação",
      unit_placeholder: "Selecione uma instalação",
      category: "Categoria",
      state: "Estado",
      municipality: "Município",
      subregion: "Sub-região",
      check_in_datetime: "Data/hora de entrada",
      check_out_datetime: "Data/hora de saída",
      company: "Fornecedor",
      company_placeholder: "Selecione um fornecedor",
      employee: "Técnico designado",
      employee_placeholder: "Selecione um técnico",
      report_number: "Ticket",
      activities: "Atividades ou tipo de projeto",
      system: "Sistemas",
      is_test_mode_enabled: "Ativar modo de teste",
      is_test_mode_enabled_placeholder: "Selecione",
      type_of_maintenance: "Tipo de manutenção",
      type_of_maintenance_placeholder: "Selecione tipo de manutenção",
      panel: "Painel",
      panel_placeholder: "Selecione o painel",
      tenant_origin: "Tenant de origem",
      tenant: "Tenant de manutenção",
      tenant_placeholder: "Selecione o tenant de manutenção",
      add_partial_checkout: "Adicionar saída parcial",
      partial_checkout_check_in_datetime: "Data/hora de início",
      partial_checkout_check_out_datetime: "Data/hora de passagem",
      partial_checkout_description: "Descrição",
      partial_checkout_is_systems_enabled: "Reativar sistemas",
      delete: "Excluir",
      generate_timestamp: "Clique para gerar marca de tempo",
      status: "Status",
      maintenance_devices: "Dispositivos em manutenção",
      sirh: "SIRH",
      rems: "REMS",
      id_seproban: "ID SEPROBAN",
      finish_maintenance: "Terminar manutenção",
      maintenance: "Manutenção",
      project_implementation: "Implementação de projetos",
      image: "Imagem",
      name: "Nome",
      step_create: "Criar",
      step_information: "Informação",
      step_panel_configuration: "Configuração do painel",
      type: "Tipo",
      user_start: "CCB de entrada",
      user_finish: "CCB de saída",
      siren_enabled: "Sirene habilitada e testada na saída",
      siren_disabled: "Sirene desabilitada no Remote na entrada",
      infrared_height: "Altura do infravermelho da área pública",
      infrared_validated: "Infravermelho validado",
      service_time: "Tempo de atendimento",
      sector: "Região",
      panel_password: "Senha do painel",
      panel_delete_password: "Senha removida do painel",
      panel_users: "Usuário técnico do painel",
      panel_users_placeholder: "Selecione um usuário do painel",
      panels_empty: "Nenhum painel foi encontrado na instalação",
      panel_users_empty: "Nenhum usuário técnico do painel foi encontrado",
      panel_user_code: "Código do usuário",
      panel_user_code_placeholder: "Clique para gerar um código",
      technicians: "Técnicos",
      devices: "Dispositivos",
    },
    create_registration: "Criar registro",
    select_form_place_holder: "Procure e selecione um formulário",
    select_facility_to_enable_command: "Selecione uma instalação para ativar o comando.",
    form_id_to_enable_command: "É necessário criar o formulário para ativar o comando.",
    crisis_form: {
      add: "Agregar Formulario de Crisis",
      title: "Formulário de crise",
      name: "Nombre",
      reference_number: "Número de referencia",
      responsable: "Responsable(s)",
      unitsAdded: "Instalaciones agregadas",
      addUnits: "Agregar instalaciones",
      emptyUnits: "No hay instalaciones agregadas",
      risk: "Risco",
      total_employees: "Total de funcionários",
      total_facilities: "Total de agências",
      buildings: "Edifícios e anexos",
      cpae: "Total CPAE´s",
      cpd: "Total CPD´s",
      facilities_atm: "Total ATM´s agências",
      third_partys_atm: "Total ATM´s terceiros",
      payroll_atm: "Total ATM´s para pagamento de salários",
      mobile_unit: "Unidade móvel",
      mobile_unit_atm: "Total ATM´s Unidade móvel",
      master_data: "Base maestra",
      allocations_by_region: "Dotações por estado",
      allocations_by_municipality: "Dotações por município",
      preventive_closures: "Encerramentos preventivos",
      offline_facilities: "Filiais offline",
      facilities_with_water_filtration_systems: "Filiais com sistemas de filtragem de água / queda de luminárias de teto",
      broken_glass: "Quebra de vidros",
      damaged_cameras: "Câmaras danificadas",
      buildings_offline: "Edifícios offline",
      buildings_with_water_leaks: "Edifícios com infiltrações de água / queda de tectos falsos",
      CPAES_offline: "CPAEs offline",
      CPAES_closures: "CPAEs cierre",
      facilities_with_offline_ATMs: "ATM´s offline filiais",
      third_party_offline_ATMs: "ATM´s offline terceiros / folha de pagamento",
      officials_contacted: "Funcionários contactados",
      support_civil_servants: "Apoio aos funcionários",
      blocked_roads: "Estradas/vias bloqueadas",
      total_branches: "Total de agências",
      total_mobile_unit: "Total de unidades móveis",
      total_atms: "Total de ATMs",
      total_emergency_kits_delivered: "Total de kits de emergência entregues",
      total_generators_delivered: "Total de geradores entregues",
      csis: "CSIS",
      csis_days_in_field: "Dias de CSIS em campo",
      csis_total_volunteers: "Total de voluntários do CSIS",
      loss: "Perdas",
      operational: "Operacional",
      total_affecting_cash: "Total afetando dinheiro",
      cash_impact: "Impacto no dinheiro",
      total: "Total",
      level: "Nivel",
      description: "Descripción",
      to_list_id: "Para",
      cc_list_id: "Copia",
      bcc_list_id: "Copia oculta",
      allocations_by_facility: "Dotações por filial",
      inpact_on_operations: "Impacto nas operações",
      complete_closure: "Encerramento completo",
      early_closing: "Encerramento antecipado",
      late_opening: "Abertura tardia",
      out_of_service: "Fora de serviço",
      offline: "Offline",
      reset: "Redefinir",
      CCTV: "CCTV",
      water_leakage: "Infiltração de água e queda de luminárias de teto",
      public_courtyard: "Pátio público",
      etv_transfer_box: "Caixa de transferência ETV",
      internal_areas: "Áreas internas",
      box_train: "Tren de cajas",
      atm_area: "Área de ATM",
      parkin: "Estacionamento",
      broken_glass: "Quebra de vidros",
      side_walls_or_facade: "Paredes laterais ou fachada",
      main_entrance: "Entrada principal",
      atm_in_operation: "ATM em operação",
      atm_damages: "Quebra de ATM",
      broken_screen: "Quebra de tela",
      broken_lock: "Chapa dañada",
      open: "Abierto",
      risk_facilities: "Filiais de risco",
      has_operational_backup_power: "Cuenta con planta de emergencia funcional",
      backup_power_capacity: "Capacidade de emergência da planta",
      diesel_level: "Nível de diésel",
      UPS: "UPS",
      facility_with_anticyclonic_curtain: "Filial com cortina anticiclônica",
      facility_with_glass_facade: "Filial com fachada de vidro",
      facility_near_rivers: "Filial próxima a rios",
      metal_roof: "Telhado de metal",
      encased_in_solid_material: "Encapsulado em material sólido",
      at_the_mall: "No shopping",
      vacant_lots: "Lotes vagos",
      employee_information_by_facility: "Informações sobre os funcionários por filial ",
      employee_name: "Nome do funcionário",
      geid: "GEID",
      employee_position: "Cargo de funcionário",
      contact_number: "Número de telefone",
      emergency_number: "Número de emergência",
      street_address_house_number: "Endereço (rua e número)",
      neighborhood: "Colónia",
      municipality: "Município",
      assigned_sirh: "SIRH atribuído",
      facility_name: "Nome da sucursal",
      status_confirmation_call_tree: "Confirmação do estado através da resposta da árvore de chamadas",
      i_feel_fine: "Sinto-me bem",
      by_mistake: "Por engano",
      need_help: "Preciso de ajuda",
      unreachable: "não localizável",
      evacuated: "Evacuado",
      contacted_by: "Contactado por",
      ccb: "CCB",
      business: "Negócio",
      csis: "CSIS",
      damages_and_needs: "Danos e necessidades",
      flooded_home: "Casa inundada",
      shortage_of_food_supplies: "Escassez de alimentos",
      emergency_plant: "Planta de emergência",
      damaged_vehicle: "Veículo danificado",
      lack_of_public_transportation: "Falta de transportes públicos",
      filters_by_region_city: "Filtros por estado, município.",
      only_rows_with_data: "Solo filas con información"
    },
    confirmGoBack: "Tem a certeza de que deseja sair?",
    confirmGoBackSubtitle: "Se tiver alterações não guardadas, elas serão perdidas.",
    show_horizontal_form: "Mostrar formulário",
    close_horizontal_form: "Fechar formulário",
    security_manager_comments: "Comentarios del director de seguridad",
    save_comments: "Guardar comentarios",
    save_comments_success: "Comentário guardado com sucesso",
    sec_manager_comments: "Comentários do diretor de segurança",
    sirh_facility_name: 'SIRH y Nome instalação',
    security_monitoring: 'Acompanhamento da segurança física',
    last24h: 'Últimas 24 horas',
    last48h: 'Últimas 48 horas',
    lastWeek: 'Última semana',
    lastMonth: 'Último mês',
    significant_event_pending_comments: 'Evento relevante pendente de comentários',
    significant_event_save_success: 'Informação relevante guardada corretamente',
  },
};
